import React from "react";
import { SafetyInspectionLocation, safetyInspectionSummaryHelper } from "../../../../amorg-common";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { ListRow } from "../../../../designSystem/compositeComponents/ListRow";
import { H3 } from "../../../../designSystem/typography/Heading";
import { FacilityPanel } from "./FacilityPanel";
import { getInspectionPointStatusIconDetails } from '../../../../utils/facilityHelper';
import { Span } from "../../../../designSystem/typography/Body";
import { ResponsiveDeviceViewLimiter } from "../../../../designSystem/ResponsiveDeviceViewLimiter";

type LocationPanelProps = {
    activityId: string,
    location: SafetyInspectionLocation,
    expanded: boolean,
    onToggleExpand: (locationId: string, expanded: boolean) => void,
    onClickCreate: (locationId: string) => void;
    onUpdate:()=>void,
    readOnly?: boolean
};

export function LocationPanel (props: LocationPanelProps): JSX.Element
{
    const summary = safetyInspectionSummaryHelper.getLocationInspectionSummary(props.location);
    let color = getInspectionPointStatusIconDetails('pending').color;
    if(summary.total > 0 && summary.passed === summary.total)
        color = getInspectionPointStatusIconDetails('passed').color;
    else if(summary.total > 0 && summary.failed > 0)
        color = getInspectionPointStatusIconDetails('failed').color;

    const statusText = summary.total > 0
        ?   <>
                {summary.pending === summary.total &&
                    <Span size="14px">Afventer</Span>
                }

                {summary.pending > 0 && summary.pending < summary.total &&
                    <Span size="14px">Under afvikling</Span>
                }

                {summary.pending === 0 &&
                    <>
                        {summary.passed === summary.total  
                            ? <Span size="14px">Gennemført - alle godkendt</Span>
                            : <Span size="14px">Gennemført - med mangler</Span>
                        }
                    </>
                }
            </>
        : <></>;
                        

    return (
        <Flex flexDirection="column">
            <ListRow
                styleVariant="outlined"
                stripColor={color}
                icon='facility_domain'
                childRows={[
                    props.location.facilities.sort((f1, f2) => f1.name.localeCompare(f2.name)).map(f =>
                    {
                        return (
                            <FacilityPanel key={f.facilityId} activityId={props.activityId} locationId={props.location.locationId} facility={f} onUpdate={props.onUpdate} readOnly={props.readOnly} />
                        );
                    })
                ]}
                collapsed={!props.expanded}
                onCollapse={
                    props.location.facilities.length > 0
                        ? (collapsed: boolean) => props.onToggleExpand(props.location.locationId, !collapsed)
                        : undefined
                }
                content={
                    <Flex flexDirection='row' gap={24} alignItems="center" style={{ marginLeft: '10px' }}>
                        <H3>{props.location.name}</H3>

                        <ResponsiveDeviceViewLimiter tablet desktop>
                            {statusText}
                        </ResponsiveDeviceViewLimiter>

                    </Flex>
                } />
        </Flex>
    );
}
